import { Box, Container, Grid, Typography, useTheme } from "@mui/material";
import { clientLogos } from "../../data/clientsLogos";
import ClientLogoCard from "../common/ClientLogoCard";
import SectionYellowTitle from "../common/SectionYellowTitle";
import SectionMainTitle from "../common/SectionMainTitle";

const ClientLogosSection: React.FC = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.default,
        py: 10,
      }}
    >
      <Container maxWidth="lg">
        {/* Sección amarillo pequeño */}
        <SectionYellowTitle title={clientLogos.subtitles} />
        {/* Título */}
        <SectionMainTitle title={clientLogos.title} />

        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary,
            textAlign: "justify",
            mb: 6,
            mx: "auto",
          }}
        >
          {clientLogos.description}
        </Typography>

        {/* Sección logos clientes */}
        <Grid container spacing={{ md: 4, xs: 2 }} justifyContent="center">
          {clientLogos.logos.map((client, index) => (
            <Grid size={{ xs: 6, sm: 4, md: 3 }} key={index}>
              <ClientLogoCard image={client.image} name={client.name} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default ClientLogosSection;
